<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <Breadcrumbs main="Fleet Analytics" title="default" />

  <div class="container-fluid p-0">
    <div class="row widget-grid">
      <div class="px-2">
        <FilterS9
        @filterHandle="filterHandle"
       />
      </div>
      <el-row 

        class="m-0 width-100-p mt-3"
        v-if="!showBarChart">
        <!-- Vehicles Manufacture Year -->
        <el-col
          class="d-flex align-item-center px-2"
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
        >
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
          >
            <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">Manufacture Year</h5>
            </el-col>
            <!-- bar Chart -->
            <el-col
              :span="24"
              v-loading="loadingChart"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
              <div id="chart">
                <apexchart
                  v-if="barChartSeries && barChartSeries[0] && barChartSeries[0].data && barChartSeries[0].data.length > 0"
                  ref="chart"
                  :key="'bar-chart-' + chartKey"
                  type="bar"
                  height="350"
                  :options="barChartOptions"
                  :series="barChartSeries"
                ></apexchart>
                <div v-else class="text-center text-white p-4">
                  No data available
                </div>
              </div>
            </el-col>
          </div>
        </el-col>
        <!-- Operating Partner -->
        <el-col
          class="d-flex align-item-center px-2"
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
        >
          <div
            class="row m-0 bg-me-primary border-color-light width-100-p rounded-4"
          >
            <el-col :span="24">
              <h5 class="text-white mt-3 ml-1">Operating Partner</h5>
            </el-col>
            <!-- pie Chart -->
            <el-col
              :span="24"
               v-loading="loadingChart"
              :element-loading-spinner="svg"
              element-loading-svg-view-box="-10, -10, 50, 50"
              element-loading-background="rgba(122, 122, 122, 0.8)"
            >
               <div id="chart">
                 <apexchart
                   v-if="pieChartSeries && pieChartSeries.length > 0"
                   ref="chart"
                   :key="'pie-chart-' + chartKey"
                   type="pie"
                   height="350"
                   :options="pieChartOptions"
                   :series="pieChartSeries"
                 ></apexchart>
                 <div v-else class="text-center text-white p-4">
                   No data available
                 </div>
               </div>
            </el-col>
          </div>
        </el-col>
        <!-- History -->
        <el-col
          class="d-flex align-item-center"
          :span="$vuetify.display.width >= 1500 ? 8 : 24"
          :class="$vuetify.display.width < 1500 ? 'mt-2' : ''"
        >
          <div class="row m-0 width-100-p">
            <el-col
             :class="$vuetify.display.width >= 1500 ? 'd-flex align-item-center px-10 py-0 mb-10' : $vuetify.display.width > 750 ? 'd-flex align-item-center px-10 py-0 mt-20' : 'd-flex align-item-center px-10 py-0 mt-20'"
              :span="
                $vuetify.display.width >= 1500 || $vuetify.display.width < 750
                  ? 24
                  : 12
              "
            >
              <div
                class="row m-0 py-0 width-100-p bg-me-primary border-color-light rounded-4"
              >
                  <el-col :span="24">
                    <h5 class="text-white mt-3 ml-1">Battery Capacity</h5>
                  </el-col>
                <el-col :span="24" class="px-3 y-center">
                  <!-- plot box Chart -->
                  <el-col
                    :span="24"
                    v-loading="loadingChart"
                    :element-loading-spinner="svg"
                    element-loading-svg-view-box="-10, -10, 50, 50"
                    element-loading-background="rgba(122, 122, 122, 0.8)"
                  >
                    <div id="chart">
                      <apexchart
                        v-if="plotBoxChartSeries && plotBoxChartSeries[0] && plotBoxChartSeries[0].data && plotBoxChartSeries[0].data.length > 0"
                        ref="chart"
                        :key="'boxplot-chart-' + chartKey"
                        type="boxPlot"
                        height="200"
                        :options="plotBoxChartOptions"
                        :series="plotBoxChartSeries"
                      ></apexchart>
                      <div v-else class="text-center text-white p-4">
                        No data available
                      </div>
                    </div>
                  </el-col>
                </el-col>
              </div>
            </el-col>
            <el-col
              :class="$vuetify.display.width >= 1500 ? 'd-flex align-item-center px-10 py-0 mt-10' : $vuetify.display.width > 750 ? 'd-flex align-item-center px-10 py-0 mt-20' : 'd-flex align-item-center px-10 py-0 mt-20'"
              :span="
                $vuetify.display.width >= 1500 || $vuetify.display.width < 750
                  ? 24
                  : 12
              "
            >
              <div
                class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
              >
                <el-col :span="17" class="px-3 y-center">
                  <div>
                    <div class="width-100-p p-2">
                      <p class="font-25-b text-white mb-0">
                        {{
                          totalCount
                        }}
                      </p>
                    </div>
                    <p class="font-16 p-2 mt-2 text-white mb-0">
                      {{ selectedTable }} Count
                    </p>
                  </div>
                </el-col>
                <el-col :span="7" class="pl-0 x-y-center">
                  <div class="width-80 height-80">
                    <svg>
                      <use href="@/assets/svg/icon-sprite.svg#avoided-fossil-fuel-icon"></use>
                    </svg>
                  </div>
                </el-col>
              </div>
            </el-col>
          </div>
        </el-col>
      </el-row>
      <el-row class="m-0 width-100-p mt-3">
        <el-col class="d-flex align-item-center px-2" :span="24">
          <div class="row m-0 width-100-p">
            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
              <SessionTable
                :filterProp="filter"
                @changeTab="changeTab"
                @sessionDataToParent="sessionDataToParent"
                />
            </div>
          </div>
        </el-col>
      </el-row>


    </div>

  </div>
</template>

<script>
import UserService from "../../../services/user.service";
import { barChart, pieChart, plotBoxChart } from "./config.js";
import { createLoadingInstance } from "../common/common-tools";
import FilterS9 from "../common/filter-s9.vue";
import SessionTable from "./fleetAnalyticsTables.vue";

export default {
  props: {},
  components: {
    // Filter,
    SessionTable,
    FilterS9
  },
  data() {
    return {
      // check which table is showing
      selectedTable: "vehicles",
      selectedTableFromChild: "vehicles",

      selectedPeriod: "All",
      barChartSeries: barChart.series,
      barChartOptions: barChart.chartOptions,

      pieChartSeries: pieChart.series,
      pieChartOptions: pieChart.chartOptions,

      plotBoxChartSeries: plotBoxChart.series,
      plotBoxChartOptions: plotBoxChart.chartOptions,

      sumTotalUsage: 0,

      sessionCardData: {
        total_count: 0,
        total_usage: 0,
      }, // total number of sessions

      states: [],
      filter: {
        customer_id: null,
      },
      SessionData: [],
      pendingSessionData: [],

      childSessionData: [],
      childPendingSessionData: [],

      loadingChart: false,

      chartKey: 0,

      selectedGroupBy: "",
      OthersCount: 0,
      totalCount: 0,
      // pagination for chart two
      largeDataset: [],
      categoryLabels: [],
      totalDataPoints: 5000,
      pageSize: 25,
      currentPage: 0,
      paginatedChartOptions: {},
      paginatedSeries: [],
      showPaginationButton: false,

    };
  },
  watch: {
    "filter.customer_id": function(val) {
      // console.log("filter.customer_id : ", val);
      if(val == "") {
        this.filter.customer_id = null;
        this.fetchFleetAnalyticsChartsData();
      }
      if(val && val !== "") {
        this.fetchFleetAnalyticsChartsData();
      }
    },

    "selectedTableFromChild": function(val) {
      if(val && val !== "") {
        this.fetchFleetAnalyticsChartsData();
      }
    },

    // pagination for chart two
    paginatedData: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    paginatedLabels: {
      handler: "handlePaginatedLabels",
      immediate: true,
    },
  },
  computed: {
    stateList() {
      return this.states;
    },

    // pagination for chart two
    paginatedData() {
      let start = this.currentPage * this.pageSize;
      let end = start + this.pageSize;
      return this.largeDataset.slice(start, end);
    },

    paginatedLabels() {
      let start = this.currentPage * this.pageSize;
      let end = start + this.pageSize;
      return this.categoryLabels.slice(start, end);
    },
  },

  async mounted() {
    const loading = createLoadingInstance();

    // Initialize chart data safely
    this.initializeChartData();

    await this.fetchFleetAnalyticsChartsData();
    setTimeout(() => {
      console.log("preloading closed");
      loading.close();
    }, 1000);
  },

  beforeUnmount() {
    this.resetChartsData();
  },

  methods: {
    // Initialize chart data with safe defaults
    initializeChartData() {
      // Ensure bar chart has proper structure
      if (!this.barChartSeries || !Array.isArray(this.barChartSeries)) {
        this.barChartSeries = [{
          data: [],
          name: "Number of vehicles",
          color: "#78BE20",
        }];
      }

      // Ensure pie chart has proper structure
      if (!this.pieChartSeries || !Array.isArray(this.pieChartSeries)) {
        this.pieChartSeries = [];
      }

      // Ensure plot box chart has proper structure
      if (!this.plotBoxChartSeries || !Array.isArray(this.plotBoxChartSeries)) {
        this.plotBoxChartSeries = [{
          data: [],
          name: "Capacity",
        }];
      }

      // Ensure chart options have proper structure
      if (!this.barChartOptions || !this.barChartOptions.xaxis) {
        this.barChartOptions = { ...this.barChartOptions, xaxis: { categories: [] } };
      }

      if (!this.pieChartOptions || !this.pieChartOptions.labels) {
        this.pieChartOptions = { ...this.pieChartOptions, labels: [] };
      }
    },

    // fetch fleet analytics charts data
    async fetchFleetAnalyticsChartsData() {
      let request = {
        command: this.selectedTableFromChild,
        customer_id: this.filter.customer_id,
      }
      this.chartKey += 1;

      try {
        const response = await UserService.FleetAnalyticsCharts(request);

        if(!response || !response.data) {
          console.log("Fleet analytics charts data is invalid - no response data");
          this.resetChartsData();
          return;
        }

        const { pie_chart_data, bar_chart_data, plot_box_data } = response.data;

        // Validate data structure
        if(!pie_chart_data || !bar_chart_data || !plot_box_data) {
          console.log("Fleet analytics charts data is invalid - missing chart data");
          this.resetChartsData();
          return;
        }

        // console.log("Fleet analytics charts data: ", response.data);
        await this.processChartsData(response.data);
      } catch (error) {
        console.log("Fleet analytics charts data error: ", error.message);
        this.resetChartsData();

        if (error.response && error.response.status == 401) {
          this.$router.push({
            path: "/",
          });
        }
      }
    },

    resetChartsData() {
      try {
        // Reset bar chart data
        if (this.barChartSeries && this.barChartSeries[0]) {
          this.barChartSeries[0].data = [];
        }
        if (this.barChartOptions && this.barChartOptions.xaxis) {
          this.barChartOptions.xaxis.categories = [];
        }

        // Reset plot box chart data
        if (this.plotBoxChartSeries && this.plotBoxChartSeries[0]) {
          this.plotBoxChartSeries[0].data = [];
        }
        if (this.plotBoxChartOptions && this.plotBoxChartOptions.xaxis) {
          this.plotBoxChartOptions.xaxis.categories = [];
        }

        // Reset pie chart data
        this.pieChartSeries = [];
        if (this.pieChartOptions) {
          this.pieChartOptions.labels = [];
        }
      } catch (error) {
        console.log("Error resetting charts data: ", error.message);
      }
    },

    async processChartsData(responseData) {
      this.loadingChart = true;

      await this.resetChartsData();

      try {

      // Process Pie Chart Data
      const pieChartData = responseData.pie_chart_data;
      if (pieChartData && pieChartData.length > 0) {
        // Group data by operating_partner to handle multiple entries with same partner
        const groupedData = {};
        pieChartData.forEach(item => {
          const partner = item.operating_partner || 'Unknown';
          if (groupedData[partner]) {
            groupedData[partner] += item.num_vehicles;
          } else {
            groupedData[partner] = item.num_vehicles;
          }
        });

        // Convert grouped data to arrays for the chart
        const pieData = Object.values(groupedData);
        const pieLabels = Object.keys(groupedData);

        this.pieChartSeries = pieData;

        this.pieChartOptions = {
          ...this.pieChartOptions,
          labels: pieLabels
        };
      }

    } catch (error) {
      console.log("Error processing charts data: ", error.message);
      this.resetChartsData();
      return;
    }




    try {
      // Process Plot Box Chart Data
      const plotBoxData = responseData.plot_box_data;
      if (plotBoxData && plotBoxData.length > 0) {
        const item = plotBoxData[0]; // Get the single item directly

        // Validate that all required properties exist
        if (item && typeof item.min_capacity === 'number' &&
            typeof item.q1 === 'number' && typeof item.median === 'number' &&
            typeof item.q3 === 'number' && typeof item.max_capacity === 'number') {

          const boxPlotData = [
            item.min_capacity,
            item.q1,
            item.median,
            item.q3,
            item.max_capacity
          ];

          // Update the existing series structure
          if (this.plotBoxChartSeries && this.plotBoxChartSeries[0]) {
            this.plotBoxChartSeries[0].data = [{
              x: 'Capacity',
              y: boxPlotData
            }];
          } else {
            this.plotBoxChartSeries = [{
              data: [{
                x: 'Capacity',
                y: boxPlotData
              }],
              name: "Capacity",
            }];
          }

          this.plotBoxChartOptions = {
            ...this.plotBoxChartOptions
          };
        } else {
          console.log("Invalid box plot data structure");
        }
      }
    } catch (error) {
      console.log("Error processing plot box chart data: ", error.message);
      this.resetChartsData();
      return;
    }

    try {
      // Process Bar Chart Data
      const barChartData = responseData.bar_chart_data;
      if (barChartData && barChartData.length > 0) {
        let series = [];
        let labels = [];

        barChartData.forEach((item) => {
          series.push(item.num_vehicles);
          labels.push(item.manufacture_year);
        });

        // Update the existing series structure
        if (this.barChartSeries && this.barChartSeries[0]) {
          this.barChartSeries[0].data = series;
        } else {
          this.barChartSeries = [{
            data: series,
            name: "Number of vehicles",
            color: "#78BE20",
          }];
        }

        // Update xaxis categories
        this.barChartOptions = {
          ...this.barChartOptions,
          xaxis: {
            ...this.barChartOptions.xaxis,
            categories: labels,
          },
        };
      }

    } catch (error) {
      console.log("Error processing bar chart data: ", error.message);
      this.resetChartsData();
      return;
    }

    this.loadingChart = false;

    },

    filterHandle(event) {
      console.log("filterHandle : ", event);
      this.filter = event;
    },

    // receive data from child component | used in sessionTable | update card data when tab is changed
    changeTab(event) {

      this.sessionCardData.total_count = event.total_count;
      this.sessionCardData.total_usage = event.total_usage;

    },

    // receive data from child component | used in sessionBarCharts
    sessionDataToParent(event) {
      this.totalCount = event.totalCount;
      this.selectedTable = event.command == "vehicles" ? "Vehicles" :  event.command == "unallocated_vehicles" ? "Unallocated Vehicles" : "";
      this.selectedTableFromChild = event.command;
    },

  },
};
</script>

<style scoped>

.pagination {
  margin-top: 10px;
  margin-bottom: 15px;
}
.pagination > .el-button {
  margin: 5px;
  padding: 10px;
  cursor: pointer;
}

</style>
